import type { AbstractIntlMessages } from 'next-intl';
import type { Locale } from '@/i18n/config';

// en
import enAccount from './en/account.json';
import enAgents from './en/agents.json';
import enAnalysis from './en/analysis.json';
import enAssistant from './en/assistant.json';
import enAuth from './en/auth.json';
import enBilling from './en/billing.json';
import enBrands from './en/brands.json';
import enCitations from './en/citations.json';
import enCommon from './en/common.json';
import enContent from './en/content.json';
import enDashboard from './en/dashboard.json';
import enIntegrations from './en/integrations.json';
import enJourney from './en/journey.json';
import enKeywords from './en/keywords.json';
import enMentions from './en/mentions.json';
import enNav from './en/nav.json';
import enOnboarding from './en/onboarding.json';
import enPartners from './en/partners.json';
import enPremium from './en/premium.json';
import enPublic from './en/public.json';
import enPublisher from './en/publisher.json';
import enPublisherContent from './en/publisherContent.json';
import enReports from './en/reports.json';
import enSearchQueries from './en/searchQueries.json';
import enShared from './en/shared.json';
import enSidebar from './en/sidebar.json';
import enSources from './en/sources.json';
import enSupport from './en/support.json';
import enTasks from './en/tasks.json';
import enTemplates from './en/templates.json';
import enTraffic from './en/traffic.json';
import enUserMenu from './en/userMenu.json';
import enVerticals from './en/verticals.json';
import enWelcome from './en/welcome.json';
import enVitals from './en/vitals.json';

// es
import esAccount from './es/account.json';
import esAgents from './es/agents.json';
import esAnalysis from './es/analysis.json';
import esAssistant from './es/assistant.json';
import esAuth from './es/auth.json';
import esBilling from './es/billing.json';
import esBrands from './es/brands.json';
import esCitations from './es/citations.json';
import esCommon from './es/common.json';
import esContent from './es/content.json';
import esDashboard from './es/dashboard.json';
import esIntegrations from './es/integrations.json';
import esJourney from './es/journey.json';
import esKeywords from './es/keywords.json';
import esMentions from './es/mentions.json';
import esNav from './es/nav.json';
import esOnboarding from './es/onboarding.json';
import esPartners from './es/partners.json';
import esPremium from './es/premium.json';
import esPublic from './es/public.json';
import esPublisher from './es/publisher.json';
import esPublisherContent from './es/publisherContent.json';
import esReports from './es/reports.json';
import esSearchQueries from './es/searchQueries.json';
import esShared from './es/shared.json';
import esSidebar from './es/sidebar.json';
import esSources from './es/sources.json';
import esSupport from './es/support.json';
import esTasks from './es/tasks.json';
import esTemplates from './es/templates.json';
import esTraffic from './es/traffic.json';
import esUserMenu from './es/userMenu.json';
import esVerticals from './es/verticals.json';
import esWelcome from './es/welcome.json';
import esVitals from './es/vitals.json';

// pt
import ptAccount from './pt/account.json';
import ptAgents from './pt/agents.json';
import ptAnalysis from './pt/analysis.json';
import ptAssistant from './pt/assistant.json';
import ptAuth from './pt/auth.json';
import ptBilling from './pt/billing.json';
import ptBrands from './pt/brands.json';
import ptCitations from './pt/citations.json';
import ptCommon from './pt/common.json';
import ptContent from './pt/content.json';
import ptDashboard from './pt/dashboard.json';
import ptIntegrations from './pt/integrations.json';
import ptJourney from './pt/journey.json';
import ptKeywords from './pt/keywords.json';
import ptMentions from './pt/mentions.json';
import ptNav from './pt/nav.json';
import ptOnboarding from './pt/onboarding.json';
import ptPartners from './pt/partners.json';
import ptPremium from './pt/premium.json';
import ptPublic from './pt/public.json';
import ptPublisher from './pt/publisher.json';
import ptPublisherContent from './pt/publisherContent.json';
import ptReports from './pt/reports.json';
import ptSearchQueries from './pt/searchQueries.json';
import ptShared from './pt/shared.json';
import ptSidebar from './pt/sidebar.json';
import ptSources from './pt/sources.json';
import ptSupport from './pt/support.json';
import ptTasks from './pt/tasks.json';
import ptTemplates from './pt/templates.json';
import ptTraffic from './pt/traffic.json';
import ptUserMenu from './pt/userMenu.json';
import ptVerticals from './pt/verticals.json';
import ptWelcome from './pt/welcome.json';
import ptVitals from './pt/vitals.json';

// fr
import frAccount from './fr/account.json';
import frAgents from './fr/agents.json';
import frAnalysis from './fr/analysis.json';
import frAssistant from './fr/assistant.json';
import frAuth from './fr/auth.json';
import frBilling from './fr/billing.json';
import frBrands from './fr/brands.json';
import frCitations from './fr/citations.json';
import frCommon from './fr/common.json';
import frContent from './fr/content.json';
import frDashboard from './fr/dashboard.json';
import frIntegrations from './fr/integrations.json';
import frJourney from './fr/journey.json';
import frKeywords from './fr/keywords.json';
import frMentions from './fr/mentions.json';
import frNav from './fr/nav.json';
import frOnboarding from './fr/onboarding.json';
import frPartners from './fr/partners.json';
import frPremium from './fr/premium.json';
import frPublic from './fr/public.json';
import frPublisher from './fr/publisher.json';
import frPublisherContent from './fr/publisherContent.json';
import frReports from './fr/reports.json';
import frSearchQueries from './fr/searchQueries.json';
import frShared from './fr/shared.json';
import frSidebar from './fr/sidebar.json';
import frSources from './fr/sources.json';
import frSupport from './fr/support.json';
import frTasks from './fr/tasks.json';
import frTemplates from './fr/templates.json';
import frTraffic from './fr/traffic.json';
import frUserMenu from './fr/userMenu.json';
import frVerticals from './fr/verticals.json';
import frWelcome from './fr/welcome.json';
import frVitals from './fr/vitals.json';

export const messages: Record<Locale, AbstractIntlMessages> = {
  en: {
    account: enAccount,
    agents: enAgents,
    analysis: enAnalysis,
    assistant: enAssistant,
    auth: enAuth,
    billing: enBilling,
    brands: enBrands,
    citations: enCitations,
    common: enCommon,
    content: enContent,
    dashboard: enDashboard,
    integrations: enIntegrations,
    journey: enJourney,
    keywords: enKeywords,
    mentions: enMentions,
    nav: enNav,
    onboarding: enOnboarding,
    partners: enPartners,
    premium: enPremium,
    public: enPublic,
    publisher: enPublisher,
    publisherContent: enPublisherContent,
    reports: enReports,
    searchQueries: enSearchQueries,
    shared: enShared,
    sidebar: enSidebar,
    sources: enSources,
    support: enSupport,
    tasks: enTasks,
    templates: enTemplates,
    traffic: enTraffic,
    userMenu: enUserMenu,
    verticals: enVerticals,
    welcome: enWelcome,
    vitals: enVitals,
  },
  es: {
    account: esAccount,
    agents: esAgents,
    analysis: esAnalysis,
    assistant: esAssistant,
    auth: esAuth,
    billing: esBilling,
    brands: esBrands,
    citations: esCitations,
    common: esCommon,
    content: esContent,
    dashboard: esDashboard,
    integrations: esIntegrations,
    journey: esJourney,
    keywords: esKeywords,
    mentions: esMentions,
    nav: esNav,
    onboarding: esOnboarding,
    partners: esPartners,
    premium: esPremium,
    public: esPublic,
    publisher: esPublisher,
    publisherContent: esPublisherContent,
    reports: esReports,
    searchQueries: esSearchQueries,
    shared: esShared,
    sidebar: esSidebar,
    sources: esSources,
    support: esSupport,
    tasks: esTasks,
    templates: esTemplates,
    traffic: esTraffic,
    userMenu: esUserMenu,
    verticals: esVerticals,
    welcome: esWelcome,
    vitals: esVitals,
  },
  pt: {
    account: ptAccount,
    agents: ptAgents,
    analysis: ptAnalysis,
    assistant: ptAssistant,
    auth: ptAuth,
    billing: ptBilling,
    brands: ptBrands,
    citations: ptCitations,
    common: ptCommon,
    content: ptContent,
    dashboard: ptDashboard,
    integrations: ptIntegrations,
    journey: ptJourney,
    keywords: ptKeywords,
    mentions: ptMentions,
    nav: ptNav,
    onboarding: ptOnboarding,
    partners: ptPartners,
    premium: ptPremium,
    public: ptPublic,
    publisher: ptPublisher,
    publisherContent: ptPublisherContent,
    reports: ptReports,
    searchQueries: ptSearchQueries,
    shared: ptShared,
    sidebar: ptSidebar,
    sources: ptSources,
    support: ptSupport,
    tasks: ptTasks,
    templates: ptTemplates,
    traffic: ptTraffic,
    userMenu: ptUserMenu,
    verticals: ptVerticals,
    welcome: ptWelcome,
    vitals: ptVitals,
  },
  fr: {
    account: frAccount,
    agents: frAgents,
    analysis: frAnalysis,
    assistant: frAssistant,
    auth: frAuth,
    billing: frBilling,
    brands: frBrands,
    citations: frCitations,
    common: frCommon,
    content: frContent,
    dashboard: frDashboard,
    integrations: frIntegrations,
    journey: frJourney,
    keywords: frKeywords,
    mentions: frMentions,
    nav: frNav,
    onboarding: frOnboarding,
    partners: frPartners,
    premium: frPremium,
    public: frPublic,
    publisher: frPublisher,
    publisherContent: frPublisherContent,
    reports: frReports,
    searchQueries: frSearchQueries,
    shared: frShared,
    sidebar: frSidebar,
    sources: frSources,
    support: frSupport,
    tasks: frTasks,
    templates: frTemplates,
    traffic: frTraffic,
    userMenu: frUserMenu,
    verticals: frVerticals,
    welcome: frWelcome,
    vitals: frVitals,
  },
};
